import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';
import { colors } from 'components/styles/_variables';

export const Wrapper = styled.div`
  background-color: ${colors.theme.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 997;
  transition: 0.3s;

  ${respondTo.default`
    height: 60px;
    padding: 0 20px;
  `}

  ${respondTo.desktop`
    width: 270px;
    position: fixed;
  `}
`;

export const Image = styled.img`
  width: 100%;
  height: 34px;

  ${respondTo.default``}
`;
